import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Autocomplete, Switch, InputAdornment } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { GridOn } from '@mui/icons-material';
import axios from 'axios';
import { exportGenericWorkbook } from '../utils/excel/genericWorkbook';
import { saveAs } from 'file-saver';

const Almacenes = () => {
      const [errorMsg, setErrorMsg] = useState('');
    // ...existing code...
    const handleActive = async (almacen, estado) => {
      try {
        await axios.put(`/api/almacen/${almacen.id}`, { ...almacen, estado });
        fetchAlmacenes();
      } catch {}
    };
  const [almacenes, setAlmacenes] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
     nombre: '',
     descripcion: '',
     id_sucursal: '',
     direccion: '',
     ubigeo: '',
     estado: 1
  });
  const [editing, setEditing] = useState(null);
  const [sucursales, setSucursales] = useState([]);
  const [ubigeos, setUbigeos] = useState([]);
  const [ubigeoInput, setUbigeoInput] = useState('');
  const [ubigeoSeleccionado, setUbigeoSeleccionado] = useState(null);

  useEffect(() => {
    fetchAlmacenes();
    fetchSucursales();
    if (form.ubigeo) {
      fetchUbigeoByCodigo(form.ubigeo);
    }
  }, []);

  useEffect(() => {
    if (!searchValue) {
      setFiltered(almacenes);
    } else {
      setFiltered(
        almacenes.filter(a =>
          (a.nombre || '').toLowerCase().includes(searchValue.toLowerCase()) ||
          (a.descripcion || '').toLowerCase().includes(searchValue.toLowerCase()) ||
          (a.direccion || '').toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    }
  }, [searchValue, almacenes]);

  const fetchAlmacenes = async () => {
    try {
      const res = await axios.get('/api/almacen');
      setAlmacenes(res.data);
    } catch (err) {
      setAlmacenes([]);
    }
  };

  const fetchSucursales = async () => {
    try {
      const res = await axios.get('/api/sucursales');
      setSucursales(res.data);
    } catch (err) {
      setSucursales([]);
    }
  };

  const handleOpen = (almacen = null) => {
    setEditing(almacen);
    setForm(almacen ? {
      nombre: almacen.nombre || '',
      descripcion: almacen.descripcion || '',
      id_sucursal: almacen.sucursal_id || '',
      direccion: almacen.direccion || '',
      ubigeo: almacen.ubigeo || '',
      estado: almacen.estado ?? 1
    } : {
      nombre: '',
      descripcion: '',
      id_sucursal: '',
      direccion: '',
      ubigeo: '',
      estado: 1
    });
    // Cargar objeto ubigeo si hay código
    if (almacen && almacen.ubigeo) {
      fetchUbigeoByCodigo(almacen.ubigeo);
    } else {
      setUbigeoSeleccionado(null);
      setUbigeoInput('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null);
  };

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  // Autocomplete ubigeo
  const handleUbigeoInput = async (_e, value) => {
    setUbigeoInput(value);
    if (value && value.length >= 2) {
      try {
        const res = await axios.get(`/api/ubigeo?q=${encodeURIComponent(value)}`);
        setUbigeos(res.data);
      } catch {
        setUbigeos([]);
      }
    } else {
      setUbigeos([]);
    }
  };

  const fetchUbigeoByCodigo = async (codigo) => {
    try {
      const res = await axios.get(`/api/ubigeo/${codigo}`);
      if (res.data && res.data.codigo) {
        setUbigeoSeleccionado(res.data);
        setUbigeoInput(`${res.data.departamento}, ${res.data.provincia}, ${res.data.distrito} (${res.data.codigo})`);
      } else {
        setUbigeoSeleccionado(null);
        setUbigeoInput('');
      }
    } catch {
      setUbigeoSeleccionado(null);
      setUbigeoInput('');
    }
  };

  const handleSave = async () => {
    setErrorMsg('');
    if (!form.nombre || !form.id_sucursal || !form.ubigeo) {
      setErrorMsg('Completa todos los campos obligatorios: Nombre, Sucursal y Ubigeo.');
      return;
    }
    const payload = { ...form, sucursal_id: form.id_sucursal };
    try {
      if (editing) {
        await axios.put(`/api/almacen/${editing.id}`, payload);
      } else {
        await axios.post('/api/almacen', payload);
      }
      fetchAlmacenes();
      handleClose();
    } catch (err) {
      setErrorMsg('Error al guardar. Verifica los datos o el servidor.');
    }
  };

  const handleDelete = async id => {
    if (window.confirm('¿Eliminar almacén?')) {
      await axios.delete(`/api/almacen/${id}`);
      fetchAlmacenes();
    }
  };

  // Exportar Excel
  const exportExcel = async () => {
    const rows = filtered.map(a => ({
      id: a.id,
      nombre: a.nombre,
      descripcion: a.descripcion,
      sucursal: sucursales.find(s => s.id === a.sucursal_id)?.nombre || '',
      direccion: a.direccion,
      ubigeo: a.ubigeo,
      estadoStr: a.estado ? 'Activo' : 'Inactivo'
    }));
    await exportGenericWorkbook({
      titulo: 'REPORTE DE ALMACENES',
      sheetName: 'Almacenes',
      tableName: 'tblAlmacenes',
      fileName: 'Almacenes',
      columns: [
        { key: 'id', label: 'ID', width: 8 },
        { key: 'nombre', label: 'Nombre', width: 28 },
        { key: 'descripcion', label: 'Descripción', width: 24 },
        { key: 'sucursal', label: 'Sucursal', width: 20 },
        { key: 'direccion', label: 'Dirección', width: 28 },
        { key: 'ubigeo', label: 'Ubigeo', width: 14 },
        { key: 'estadoStr', label: 'Estado', width: 12, isEstado: true }
      ],
      rows,
      searchText: searchValue,
      usuario: ''
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Almacenes</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={searchValue}
            onChange={e => { setSearchValue(e.target.value); setPage(0); }}
            size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={exportExcel} sx={{ minWidth: 120 }}>
            Exportar Excel
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nuevo Almacén</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Descripción</TableCell>
              <TableCell align="center">Sucursal</TableCell>
              <TableCell align="center">Dirección</TableCell>
              <TableCell align="center">Ubigeo</TableCell>
              <TableCell align="center">Estado</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered
              .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
              .map(a => (
                <TableRow key={a.id}>
                  <TableCell align="center">{a.id}</TableCell>
                  <TableCell align="center">{a.nombre}</TableCell>
                  <TableCell align="center">{a.descripcion}</TableCell>
                  <TableCell align="center">{sucursales.find(s => s.id === a.sucursal_id)?.nombre || ''}</TableCell>
                  <TableCell align="center">{a.direccion}</TableCell>
                  <TableCell align="center">{a.ubigeo}</TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={!!a.estado}
                      color="success"
                      onChange={e => handleActive(a, e.target.checked ? 1 : 0)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleOpen(a)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => handleDelete(a.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl page={page} rowsPerPage={rowsPerPage} count={filtered.length} onPageChange={setPage} />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            {editing ? 'Editar Almacén' : 'Nuevo Almacén'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {errorMsg && (
            <Typography color="error" sx={{ mb: 2 }}>{errorMsg}</Typography>
          )}
          <Grid spacing={2}>
            <Grid item xs={12} sx={{ mt: 1.5 }}>
              <TextField label="Nombre" name="nombre" value={form.nombre} onChange={handleChange} fullWidth required />
            </Grid>
            <Grid item xs={12} sx={{ mt: 1.5 }}>
              <TextField label="Descripción" name="descripcion" value={form.descripcion} onChange={handleChange} fullWidth />
            </Grid>
            <Grid item xs={12} sx={{ mt: 0.5 }}>
              <Autocomplete
                options={sucursales}
                getOptionLabel={option => option.nombre || ''}
                value={sucursales.find(s => s.id === form.id_sucursal) || null}
                onChange={(_, newValue) => setForm(f => ({ ...f, id_sucursal: newValue ? newValue.id : '' }))}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{ width: '100%' }}
                renderInput={params => (
                  <TextField {...params} label="Sucursal" margin="dense" fullWidth required />
                )}
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: 1 }}>
              <TextField label="Dirección" name="direccion" value={form.direccion} onChange={handleChange} fullWidth />
            </Grid>
            <Grid item xs={12} sx={{ mt: 0.5 }}>
              <Autocomplete
                options={ubigeos}
                getOptionLabel={option => {
                  if (!option) return '';
                  if (option.departamento && option.provincia && option.distrito) {
                    return `${option.departamento}, ${option.provincia}, ${option.distrito} (${option.codigo})`;
                  }
                  return option.codigo || '';
                }}
                value={ubigeoSeleccionado}
                inputValue={ubigeoInput}
                onInputChange={handleUbigeoInput}
                onChange={(_e, value) => {
                  setUbigeoSeleccionado(value);
                  setForm(f => ({ ...f, ubigeo: value ? value.codigo : '' }));
                  setUbigeoInput(value ? `${value.departamento}, ${value.provincia}, ${value.distrito} (${value.codigo})` : '');
                }}
                isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                filterOptions={(x) => x}
                sx={{ width: '100%' }}
                renderInput={params => (
                  <TextField {...params} label="Ubigeo" margin="dense" fullWidth required />
                )}
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: 1.5 }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Switch
                  checked={!!form.estado}
                  color="success"
                  onChange={e => setForm(f => ({ ...f, estado: e.target.checked ? 1 : 0 }))}
                />
                <Typography>{form.estado ? 'Activo' : 'Inactivo'}</Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
          <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};

export default Almacenes;
